'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _class = require('common/utils/class');

var _messages = require('common/messages');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function BaseCollection(properties) {
    var values = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];

    this.push.apply(this, _toConsumableArray(values));
    this.setProperties(properties);
}

Object.assign(BaseCollection.prototype, {
    setProperties: function setProperties(properties) {
        Object.assign(this, properties);
    },
    push: function push() {
        return this.splice.apply(this, [this.length, 0].concat(Array.prototype.slice.call(arguments)));
    },
    unshift: function unshift() {
        return this.splice.apply(this, [0, 0].concat(Array.prototype.slice.call(arguments)));
    },
    shift: function shift() {
        return this.splice(0, 1);
    },
    pop: function pop() {
        return this.splice(this.length - 1, 1);
    },
    remove: function remove() {
        for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
            values[_key] = arguments[_key];
        }

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var value = _step.value;

                var i = this.indexOf(value);
                if (~i) this.splice(i, 1);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator['return']) {
                    _iterator['return']();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    },


    /**
    * all mutation methods go through here
    */

    splice: function splice() {
        var ret = Array.prototype.splice.apply(this, arguments);
        if (this.notifier) this.notifier.notify(_messages.ChangeMessage.create(this));
        return ret;
    }
});

BaseCollection.create = (0, _class.createFactory)(Array);
BaseCollection.extend = _class.extend;

// CANNOT extend array. Copy props instead
var _iteratorNormalCompletion2 = true;
var _didIteratorError2 = false;
var _iteratorError2 = undefined;

try {
    for (var _iterator2 = Object.getOwnPropertyNames(Array.prototype)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var prop = _step2.value;

        if (BaseCollection.prototype[prop]) continue;
        var value = Array.prototype[prop];
        if (typeof value === 'function') BaseCollection.prototype[prop] = value;
    }
} catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
} finally {
    try {
        if (!_iteratorNormalCompletion2 && _iterator2['return']) {
            _iterator2['return']();
        }
    } finally {
        if (_didIteratorError2) {
            throw _iteratorError2;
        }
    }
}

BaseCollection.prototype[Symbol.iterator] = Array.prototype[Symbol.iterator];

exports['default'] = BaseCollection;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/collection/index.js
 ** module id = 602
 ** module chunks = 0
 **/